import { useL10nStore } from './stores/l10n';

export const L = (key, ...args) => {
  const text = useL10nStore().data?.[key] || key;

  return text.replace(/\{(\d+)\}/g, (match, number) => args[number] ?? match);
}
